"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpeningHours = void 0;
const react_1 = __importStar(require("react"));
const openingHours_1 = require("@geome/react-components-next/lib/components/openingHours");
const clock_1 = require("./icons/clock");
const react_next_1 = require("@geome/react-next");
const OpeningHours = ({ location }) => {
    const { translate } = (0, react_next_1.useI18n)();
    const { forecourt_opening_hours: forecourtOpeningHours, shop_opening_hours: shopOpeningHours, carwash_opening_hours: carwashOpeningHours, } = location;
    const { isMobile } = (0, react_1.useContext)(react_next_1.EnvironmentContext);
    const tables = (0, react_1.useMemo)(() => {
        const times = [
            {
                title: translate("station_page.sections.opening_hours.forecourt"),
                daysAndTimes: forecourtOpeningHours,
            },
            {
                title: translate("station_page.sections.opening_hours.shop"),
                daysAndTimes: shopOpeningHours,
            },
            {
                title: translate("station_page.sections.opening_hours.carwash"),
                daysAndTimes: carwashOpeningHours,
            },
        ].filter(({ daysAndTimes }) => Array.isArray(daysAndTimes) && daysAndTimes.length > 0);
        return times;
    }, [forecourtOpeningHours, shopOpeningHours, carwashOpeningHours]);
    return (react_1.default.createElement(openingHours_1.OpeningHours, { sectionName: "opening_hours", configPath: "station_page.", tables: tables, renderIcon: () => react_1.default.createElement(clock_1.ClockIcon, null), singleTable: !isMobile }));
};
exports.OpeningHours = OpeningHours;
